export default class AssignmentDomainService {
    static assignmentFromJson(json) {
        return Object.assign(Object.assign({}, json), { dueDate: json.dueDate && new Date(json.dueDate), createdDate: new Date(json.createdDate), lastSyncDate: new Date(json.lastSyncDate) });
    }
    static submissionFromJson(json) {
        return Object.assign(Object.assign({}, json), { submissionDate: json.submissionDate && new Date(json.submissionDate), gradedDate: json.gradedDate && new Date(json.gradedDate), lastSyncDate: new Date(json.lastSyncDate) });
    }
    static gradeFromJson(json) {
        return Object.assign(Object.assign({}, json), { lastSyncDate: new Date(json.lastSyncDate) });
    }
    static personLmsAssignmentFromJson(json) {
        return Object.assign(Object.assign({}, json), { dueDate: json.dueDate && new Date(json.dueDate), submissionDate: json.submissionDate && new Date(json.submissionDate), lastSyncDate: json.lastSyncDate && new Date(json.lastSyncDate) });
    }
}
